/** Тексты окна: Подкрепление после реванша (MADR 0019); карточки и названия усилений — `boost-choice/messages.ts`. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.reviveBoost.title": "Reinforcement {n} of {max}",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.reviveBoost.title": "Подкрепление {n} из {max}",
};

const uk: Record<Key, string> = {
  "win.reviveBoost.title": "Підкріплення {n} з {max}",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
